<template>
  <div>
    <h1 class="uk-text-center AppTitle Title">{{'about_us_view.our_partners'|translate}}</h1>
    <div class="uk-child-width-1-3@m" uk-grid
         uk-scrollspy="cls: uk-animation-fade; target: .uk-card; delay: 100; repeat: true">
      <div v-for="(item, index) in logos" :key="index">
        <div class="uk-card uk-card-default uk-card-body">
          <div class="uk-cover-container">
            <canvas width="400" height="200"></canvas>
            <img :src="item.url" alt="" uk-cover class="partners-logo">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OurPartnersComponent',
  props: ['logos']
}
</script>

<style scoped>
  .partners-logo {
    width: 100% !important;
    height: auto !important;
  }
</style>
